import { useNavigate, useParams } from "react-router";
import PurchaseOrderBreadcrumb from "./PurchaseOrderBreadcrumb"
import { useDispatch, useSelector } from "react-redux";
import { selectors as purchaseOrderSelectors} from "redux/PurchaseOrder";
import selectors from "redux/Navigation/selectors";
import { CONSTANTS } from "client/utils/constants";
import { operations } from "redux/Navigation";
import { setOrderById } from "Store/OrderManagement/Order/OrderAction";

const PurchaseOrderBreadcrumbContainer = (props:any) => {

  const {
    isBulkOrder
  } = props
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navDispatch = operations.dispatchNav(dispatch);
    let { pagename, activeassetnumber} = useParams();
    const { orderDetails, savedStatus, headerNav, bulkOrderHeaderDetails }: any = useSelector((state: any) => ({
        orderDetails: purchaseOrderSelectors.getOrderDetail(state),
        savedStatus: state.adminTaskReducer.savedStatus,
        headerNav: selectors.GetHeaderNav(state),
        bulkOrderHeaderDetails: state.PurchaseBulkOrderReducer.bulkOrderHeaderDetails
      }));
      
      const onClickBack = () => {   
        if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
          navDispatch('Customer My Orders')
        } else if(pagename === CONSTANTS.BULK_ORDER){
          navDispatch('Bulk Orders')
        } else if(pagename == 'activeasset'){
          navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
        } else{
          navDispatch('Home')
        } 
          dispatch(setOrderById({}))
          navigate('/ordermanagement');
      }

      const breadcrumlist = [
        { text: pagename == 'activeasset' ? "Active Assets Drill Through" : headerNav === "Customer My Orders" ? "Request" : headerNav, 
        key: "f1", 
        href: "/ordermanagement",
        onClick: (e: any) => {
            e.preventDefault();
            if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
              navDispatch('Customer My Orders')
            } else if(pagename === CONSTANTS.BULK_ORDER){
                navDispatch('Bulk Orders')
            } else if(pagename == 'activeasset'){
              navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
            }else{
              navDispatch('Home')
            }
            navigate('/ordermanagement');
          }, 
    },
        { text: "Purchase Order", key: "f4" },
    ];
    return(
        <PurchaseOrderBreadcrumb breadcrumlist={breadcrumlist} onClickBack={onClickBack} orderDetails={orderDetails} savedStatus={savedStatus} 
          bulkOrderHeaderDetails={bulkOrderHeaderDetails}
          isBulkOrder = {isBulkOrder}
        />
    )
}

export default PurchaseOrderBreadcrumbContainer